import React from 'react'
import '../Assets/Additionalcss/ForgotPassword.css'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast,ToastContainer } from 'react-toastify';
import axios from 'axios'
import { BASE_URL } from '../Config/Base';
const ForgotPassword = () => {

  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);

  const handleEmail = (e) => {
    setEmail(e.target.value);

  };
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    var input = document.getElementById('email').value
    if (!input) {
      document.getElementById('msg').innerHTML = "Enter Registered Mail Id"

    }
    else {
      document.getElementById('msg').innerHTML = ""
  
      SendEmail();
      //navigate("/Resetpassword");
      // setTimeout(() => {
      //   navigate("/Psw")
      // }, 1000);


    }

  }

  function onHandleChange(){

    var input = document.getElementById('email').value
    if (!input) {
      document.getElementById('msg').innerHTML = "Enter Registered Mail Id"

    }
    else {
      document.getElementById('msg').innerHTML = ""
    }
  }

  function SendEmail()
  {
    const email = document.getElementById("email").value;

    const body ={
      
      Email: email ,
      

    }


    axios({
     
      method: "POST",
       //url: `${BASE_URL}/Authenticate/SendEmailOTP`,
       url:"https://localhost:44312/Api/Authenticate/SendEmailOTP",
      data:body,
      headers: {
        
       'Content-Type': 'application/json' ,      
       

      }
    
    })
   
    .then((response) =>{

      localStorage.setItem('email',response.data.email);    
      localStorage.setItem('otp',response.data.otp);    


      console.log(response.data);
      if(response.data.status === "Error"){
   
              //toast.error("InCorrect")
              alert("Email does not Exist")
            }
        
            else if(response.data.status === "Success"){

              alert("Check The Email For Reset Password!")
 
                  navigate("/OtpVerifyPage")
              }
             
       })


       
       .catch(error => {
      console.log(error);
      alert("Please Enter The Registered Mail Id") 
      
       })
   
  }

  return (
    <div className="FPmain-container">
        <div className="FPdiv">
        <h3 className="login-title">Email</h3> 
    <form className="login-form">

    <span className='error' id="msg" ></span>
        <input
               id="email"
               type="email"
               placeholder="example@gmail.com"
               name="email"
               onKeyUp={onHandleChange}
               />
  

      <button className="FPbtn" type="submit" onClick={handleSubmit}>
       Submit
      </button>
    </form>
</div>
     
    </div>
  )
}

export default ForgotPassword;